import { FC, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDownload,
  faFileExcel,
  faFilePdf,
} from '@fortawesome/free-solid-svg-icons';
import { Menu } from 'primereact/menu';
import { exportExcel } from '@/utils/exportExcel';
import { exportPdf } from '@/utils/exportPdf';
import { useTranslation } from 'react-i18next';
import { TableData } from '../Table/types';
import Button from '../Button/Button';
import styles from './ExportTableButton.module.scss';

type ExportTableButtonProps = {
  data: TableData;
  isDisabled?: boolean;
  columnsToExport?: string[];
  fileName?: string;
  adjustTitles?: boolean;
};

const ExportTableButton: FC<ExportTableButtonProps> = ({
  data,
  isDisabled,
  columnsToExport,
  fileName,
  adjustTitles = false,
}) => {
  const { t } = useTranslation('table');

  const exportMenuRef = useRef<Menu>(null);
  const exportOptions = [
    {
      label: 'Excel (XLS)',
      icon: <FontAwesomeIcon icon={faFileExcel} className={styles.icon} />,
      command: () =>
        exportExcel({
          data,
          fileName,
          selectedColumns: columnsToExport,
        }),
    },
    {
      label: 'PDF',
      icon: <FontAwesomeIcon icon={faFilePdf} className={styles.icon} />,
      command: () =>
        exportPdf({
          data,
          fileName,
          selectedColumns: columnsToExport,
          adjustTitles,
        }),
    },
  ];

  return (
    <>
      <Button
        secondary
        className={`${styles.exportButton} w-full lg:w-auto`}
        disabled={isDisabled}
        onClick={(event) => exportMenuRef.current?.toggle(event)}
      >
        <FontAwesomeIcon icon={faDownload} className={styles.icon} />
        {t('export')}
      </Button>
      <Menu
        className={styles.exportMenu}
        model={exportOptions}
        popup
        ref={exportMenuRef}
      />
    </>
  );
};

export default ExportTableButton;
